import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerNoteForm from '../containers/PlannerNoteFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerNoteAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerNoteAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_note_route_add')} />
          <PlannerNoteForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerNoteAddScreen;

Logger.log('silly', `PlannerNoteAddScreen loaded.`);
